// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"116": "96b2ca9a","366": "9154912f","606": "69c75047","985": "482cb750",}[chunkId] + ".css"
}